let $ = jQuery;

$(function () {
    setScrollPadding();
    mobileMenu();
    addImagesToMobileMenuItems()
    // addLoginMenuForMobile()
    searchMenu();
    showCouponFields();
    updateMiniCartOnQuantityInput();
    actionQuantityUp();
    actionQuantityDown();
    showSpinnerForAddToCart();
    updateMinicCartInput();
    changeNameCategoryMobileMenu();
    showMobileSubmenu();
    backStep();
    showBackToTop();
    backToTop();
    wholesaleSlider();
    articlesSlider();
    singleHeroSlider();
    initPerPageHandler();
    scrollForForm();
    blockedZip();
    StoreLocator();
    mapFilterDropDown();
    copyToClipboard();
    animateOnScroll();
    validateWhatIsKingPalmForm();
    confirmationPopups();
    twoFACheckbox();
    logoutPopup();
    // goToCartFromHeaderCartIconForDesktop();
});

function goToCartFromHeaderCartIconForDesktop() {
    jQuery('body').on('click', '.block-minicart', function (event) {
        if ($(event.target).is('a.cart') || $(event.target).closest('a.cart').length > 0) {
            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            if (!isMobile) {
                window.location.href = "/cart/";
            }
        }
    });
}

/**
 * My account confirmation popups
 */
function confirmationPopups() {
    // Close popup
    $(".popup .close").on("click", function (e) {
        e.preventDefault();
        $(".popup").removeClass("show");
    });
}

/**
 * 2FA checkbox
 */
function twoFACheckbox() {
    $(document).on("change", "#wfls-remember-device", function (e) {
        $(this).parent().toggleClass("checked");
    });
}

/**
 * Logout popup
 */
function logoutPopup() {
    $(".woocommerce-MyAccount-navigation-link--customer-logout a, .header-menu .menu-item a[href*='customer-logout']").on("click", function (e) {
        e.preventDefault();
        // Get logout link
        let logoutLink = $(".woocommerce-MyAccount-navigation-link--customer-logout > a").attr("href");

        if (!logoutLink) {
            logoutLink = $(".nav.mobile-login li:first").find('ul.sub-menu li:last').find('a').attr('href');
        }

        // Show popup
        $("#popup-logout").addClass("show");

        // Set logout link for confirmation button
        $("#popup-logout .btn-ok").attr("href", logoutLink);
    });
}

/**
 * Copy to clipboard
 */
function copyToClipboard() {
    function copyFromText(selectors, appendCopiedTextTo) {
        $(selectors).each(function (_, element) {
            $(element).on('click', function (e) {
                copyToClipboard($(e.target).text().trim(), appendCopiedTextTo);
            });
        });
    }

    function copyToClipboard(str, appendCopiedTextTo) {
        let timeoutId;
        const el = $('<textarea></textarea>').addClass('temp-textarea').val(str);
        $("body").append(el);
        el.select();
        document.execCommand('copy');

        $(appendCopiedTextTo).addClass("copied");

        $("body").find('.temp-textarea').remove();

        timeoutId = setTimeout(function () {
            $(appendCopiedTextTo).removeClass("copied");
        }, 2000);
    }

    copyFromText(".coupon-cover p mark", ".coupon-cover");
}

$(document).on("ready", function () {
    $('body').on('click', '.holder-form .list-radio li', function () {

        if ($(this).find('input').val() == 'show-input') {
            $(".show-input").show();
        } else {
            $(".show-input").hide();
        }
    });

    $('body').on('change click', '.select-show-input select', function () {

        var country = $(this).val();

        if (country === 'show-input') {
            $(".show-input").show();
        } else {
            $(".show-input").hide();
        }
    });
});

$(window).on("load", function () {
    function colHeight() {
        var maxH = 0;
        $(".products .product-card .product-info").each(function (i) {
            if ($(this).height() > maxH) {
                maxH = $(this).height();
            }
        });
        $(".products .product-card .product-info").height(maxH);
    }

    // colHeight();
});

$(window).on("load", function () {
    $('.landing-slider').slick({
        dots: true,
        arrows: false,
        useTransform: false,
        speed: 300,
    });

    var keyStart = ".maingalary";
    $(' .landing-slider').slick('slickUnfilter');
    $(' .landing-slider').slick('slickGoTo', 0);
    $(' .landing-slider').slick('slickFilter', keyStart).slick('refresh');


    // Filter slick
    $('.landing-item .form-radio input:not(.not-a-slick-filter)').bind('click', function () {
        const filter = $(this).data("filter");
        const key = "." + filter;

        $('.landing-slider').slick('slickUnfilter');
        $('.landing-slider').slick('slickGoTo', 0);
        $('.landing-slider').slick('slickFilter', key).slick('refresh');
    });

    // Process quantity
    $('.landing-item .form-radio input').bind('click', function () {
        const quantity = $(this).data("max_qty");

        $('.qty').attr({ "max": quantity });
        $('.qty').val(1);

        if (quantity > 0) {
            $('.holder-btn .btn').prop('disabled', false);
            priceCalc();
        } else {
            $('.holder-btn .btn').prop('disabled', true);
        }
    });

    // Check current suga punch product after the page was loaded
    if ($(".suga-current-product").length !== 0) {
        $(".suga-current-product").trigger("click");
    }

    $(".page-landing .landing-item .qty").change(function () {


        if ($('.page-landing .landing-item .form-radio input').is(':checked') && $('.page-landing .landing-item .form-radio input:checked').data("max_qty") > 0) {
            priceCalc();
        }


    });

    function priceCalc() {

        let p = $(".page-landing .landing-item .form-radio input:checked").data("regular_price") * 1;
        let q = $('.qty').val();
        let summ = p * q;
        $('.page-landing .landing-item .holder-btn .btn span').html('- $' + summ.toFixed(2));

    }
})

$(document).ready(function () {
    let resizeTimeout;

    if ($(".featured-slider .wcpscwc-product-slider .slick-slider .slick-slide").length !== 0) {
        function resizeSlide() {
            let widthProp = ($(".featured-slider .wcpscwc-product-slider .slick-slider .slick-slide").attr("style"));

            widthProp = widthProp.slice(0, -1);
            widthProp = widthProp.slice(7);

            $(":root")[0].style.setProperty("--slide-width", `${widthProp}`);
        }

        $(window).on("resize", function () {
            // Debounced resize
            clearTimeout(resizeTimeout);

            resizeTimeout = setTimeout(function () {
                resizeSlide();

                clearTimeout(resizeTimeout);
            }, 100);
        });

        $(window).trigger("resize");
    }

    // $('.select__select').change(function () {
    //     selectStock();
    // }); 
    // selectStock(); 
    function selectStock() {
        var selectedOption = $('.select__select').find('option:selected');
        var stock = selectedOption.data('stock');
        if (stock > 10) {
            $('.stock').removeClass('out-of-stock');
            $('.stock').text('In stock').addClass('in-stock');
        }
        if (stock < 10 && stock > 0) {
            $('.stock').removeClass('in-stock');
            $('.stock').text(`Only ${stock} units left`).addClass('out-of-stock');
        }
        if (stock === 0) {
            $('.stock').removeClass('in-stock');
            $('.stock').text('Out of stock').addClass('out-of-stock');
        }
    }
})

// Set scroll padding prop
function setScrollPadding() {

    let adminBarHeight = $("#wpadminbar").length !== 0 ? $("#wpadminbar").outerHeight(true) : 0;
    let headerHeight = $("#masthead").outerHeight();

    $("html").css("--scroll-padding", adminBarHeight + headerHeight + "px");
}


$('.arrow-down').on('click', function () {
    var el = $(this);
    var dest = el.attr('href');
    if (dest !== undefined && dest !== '') {
        $('html').animate({
            scrollTop: $(dest).offset().top - 100
        }, 500
        );
    }
    return false;
});


function searchMenu() {

    $('body').on('click', '.toggle-search-field', function (e) {
        e.preventDefault()
        $('.header-menu').toggleClass('open-field');
        $(".header-main #autocomplete form.search-form input.search-field").focus();

        if (!$('.header-manu').hasClass('open-field')) {
            $(".aa-Panel").remove();
        }
    })
}

function initPerPageHandler() {
    $('select[name="per-page"], select[name="per-page-mob"]').on('change', function () {
        let perPageValue = $(this).find('option:selected').val();
        var queryParams = new URLSearchParams(window.location.search);
        queryParams.set("kigpalm_shop_per_page", perPageValue);
        var pathParts = window.location.pathname.split('/');
        pathParts = pathParts.filter(val => val != '');
        var pathName = '';
        if (pathParts.length > 2 && pathParts[(pathParts.length - 2)] == 'page') {
            pathName = pathParts.slice(0, -2).join('/');
        } else {
            pathName = window.location.pathname;
        }
        var url = window.location.origin + '/' + pathName + "?" + decodeURIComponent(queryParams.toString());
        window.location.href = url;

    });
}

////////////////////////////////////mobile
// show mobile submenu
function showMobileSubmenu() {
    $('.mobile-arrow').on('click', function () {
        const subMenu = $(this).parent('.menu-item-has-children').children('.sub-menu');
        const subMenuthird = $(this).parent('.third-level').children('.sub-menu');
        const panelSubMenu = $(this).closest('.mobile-menu').find('.panel-submenu');
        subMenu.addClass('opened');
        subMenuthird.addClass('thr-level');
        panelSubMenu.addClass('show');

        // Prevent parent scroll
        subMenu.parent().closest(".sub-menu").addClass("lock");

        $(this).closest('.mobile-menu').addClass('open-submenu');

    });
}

// global value for category(mobile)
const stateMenu = {
    level0: null,
    level1: null,
};

// step back in mobile menu
function backStep() {
    $('.mobile-menu .fa-angle-left').on('click', function () {
        const backThird = $(this).closest('.mobile-menu').find('.opened').last();
        const panelSubMenu = $(this).closest('.mobile-menu').find('.panel-submenu');
        const historySubMenu = $(this).closest('.mobile-menu').find('.back');
        backThird.removeClass('opened');
        if (!$(this).closest('.mobile-menu').find('.opened').length) {
            panelSubMenu.removeClass('show');
            $(this).closest('.mobile-menu').removeClass('open-submenu');
        }
        // change name category (back step)
        if (stateMenu.level1 && stateMenu.level0) {
            historySubMenu.html(stateMenu.level0);
            stateMenu.level1 = null;

        } else if (!stateMenu.level1 && stateMenu.level0) {
            stateMenu.level0 = null;
        }

        // Allow to scroll parent
        backThird.parent().closest(".sub-menu").removeClass("lock");
    });
}

// change name category (next step)
function changeNameCategoryMobileMenu() {
    $('.mobile-menu .fa-angle-right').on('click', function (e) {
        let nameCategory = $(this).prev('a').text();
        $('.back').html(nameCategory);
        if (!stateMenu.level0) {
            stateMenu.level0 = nameCategory;
        } else if (stateMenu.level0 && !stateMenu.level1) {
            stateMenu.level1 = nameCategory;
        }
        //scroll to top after click
        $('.mobile-menu').animate(
            { scrollTop: $('.mobile-menu').offset() });
    })
}

////////////////////////////////////end mobile

function mobileMenu() {
    $(document).on("click", ".icon-down-arrow", function () {
        $(this).parent().addClass('show-sub-menu');
        const expanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !expanded);
        $('.nav > li > button').not(this).attr('aria-expanded', 'false');
    });

    $(document).on('focus', '.nav > li > ul > li > a', function () {
        $('.show-sub-menu .show-sub-menu.show-sub-menu').removeClass('show-sub-menu');
    });

    $(document).on('focus', '.nav > li > button, .nav > li > a', function () {
        $('.nav > li > button').not(this).attr('aria-expanded', 'false');
        $(".show-sub-menu").removeClass('show-sub-menu');

    });

    $(document).mouseup(function (e) {
        var div = $(".show-sub-menu");
        if (!div.is(e.target) && div.has(e.target).length === 0) {
            $('.nav > li > button').attr('aria-expanded', 'false');
            $(".show-sub-menu").removeClass('show-sub-menu');
        }
    });



    $('.sub-menu > li').each(function () {
        if ($(this).find('li').length > 10) {
            $(this).parent().addClass('use-scroll');
        }
    });
    $('.burger').on('click', function (e) {
        e.preventDefault();
        const mobileSerch = $(this).closest('.header-menu').find('.header-search');
        $(this).toggleClass('burger_active');
        $('.mobile-menu').toggleClass('opened');
        if ($(this).hasClass('burger_active')) {
            mobileSerch.hide();
        } else {
            mobileSerch.show();
        }
    });
}

// Adding images for mobile menu items
function addImagesToMobileMenuItems() {
    const menuItems = $(".mobile-menu .nav .menu-item");
    const wideItemIds = [727739, 609898, 102875, 293924, 103048, 103049, 579685, 103050, 609900, 102874, 609902, 588784, 634758, 609401, 609950, 603523, 603525, 644125, 629364];

    // Looping through the items, generating, and inserting the images
    $(menuItems).each(function (_index, item) {
        const imageWrapper = $("<span class='menu-item-image-wrapper'></span>");
        let imageSrc = $(item).data('megaMenuImageSrc');
        if (imageSrc) {
            const itemId = $(item).attr("id");
            const image = $(
                "<img src='" + imageSrc + "' class='menu-item-image' loading='lazy' alt='Menu image'>"
            );
            const link = $(item).find("> a");
            const categoryLink = $(item).not(".view-all-mobile").find("> a");

            if (itemId && wideItemIds.indexOf(parseInt(itemId.replace('menu-item-', ''))) !== -1) {
                $(item).addClass("wide-image");
            } else {
                $(item).addClass("square-image");
            }

            // Adding small image
            $(imageWrapper).append(image);
            $(imageWrapper).insertAfter(link);

            // Adding big image
            if ($(categoryLink).closest("[href$='/tubes/']").length !== 0 || $(categoryLink).closest("[href$='/pre-rolled-cones/']").length !== 0 || $(categoryLink).closest("[href$='/smoking-papers-wraps/']").length !== 0) {
                const bigImageWrapper = $(
                    "<li class='menu-item-big-image-wrapper'></li>"
                );
                let bigImageSrc = '';
                let bigImageWidth = '414';
                let bigImageHeight = '384';
                let closestSelector = '';
                if ($(categoryLink).closest("[href$='/tubes/']").length !== 0) {
                    closestSelector = '/tubes/';
                    bigImageSrc = 'https://kingpalm.com/wp-content/uploads/2023/12/just-pack-it.png';
                } else if ($(categoryLink).closest("[href$='/pre-rolled-cones/']").length !== 0) {
                    closestSelector = '/pre-rolled-cones/';
                    bigImageSrc = 'https://kingpalm.com/wp-content/uploads/2023/12/cones.png';
                } else if ($(categoryLink).closest("[href$='/smoking-papers-wraps/']").length !== 0) {
                    closestSelector = '/smoking-papers-wraps/';
                    bigImageSrc = 'https://kingpalm.com/wp-content/uploads/2023/12/papers-and-wraps.png';
                }
                const bigImage = $(
                    `<img src='${bigImageSrc}' class='menu-item-big-image' width='${bigImageWidth}' height='${bigImageHeight}' loading='lazy' alt='Category image'>`
                );

                $(bigImageWrapper).append(bigImage);
                $(categoryLink)
                    .closest("[href$='" + closestSelector + "']")
                    .parent()
                    .find("> ul.sub-menu")
                    .append(bigImageWrapper);
            }
        }
    });
}

// Adding login menu
function addLoginMenuForMobile() {
    const loginMenu = $(`
				<ul class="mobile-login-menu">
					<li class="menu-item">
						<a href="/my-account/">Login</a>
					</li>
				</ul>
			`);

    loginMenu.insertBefore(".mobile-menu .nav-second");
}


//update quantity due button update cart
function updateCart(self, input, newVal) {
    input.val(newVal);
    input.trigger('change');
    setTimeout(() => {
        spinnerQty(self);
        if (self.closest('.widget_shopping_cart_content-ab').length) {
            doUpdateMiniCart();
        } else {
            doUpdateCart(self);
        }
    }, 3000);
}

//add spinner for quantity(cart)
function spinnerQty(self) {
    if (!self.hasClass('has-spinner')) {
        return;
    }
    if (self.attr("disabled") == "disabled") {
        e.preventDefault();
    }
    //binding spinner element to button and changing button text
    self.html('<span class="spinner-quantity"><i class="fa fa-spinner fa-spin"></i></span>');
    self.addClass('active');

}
//update due hide button update cart
function doUpdateCart() {
    $("[name='update_cart']").trigger("click");
}

function updateMinicCartInput() {
    $('body').on('keyup', '.product-amount-mini-cart input', function () {
        setTimeout(() => {
            doUpdateMiniCart();
        }, 2000);
    })
}

let updateMiniCartXHR = null;
function doUpdateMiniCart() {
    if (updateMiniCartXHR !== null) {
        return false;
    }

    const newItemsQtyData = [];
    $('.widget_shopping_cart_content-ab .product-amount-mini-cart').each(function () {
        if ($(this).find('input.qty').length) {
            newItemsQtyData.push({
                cart_item_key: $(this).data('cart_key'),
                cart_item_qty: $(this).find('input.qty').val(),
            })
        }
    })
    let data = {
        action: "kingpalm_mini_cart_update_qty",
        items: newItemsQtyData
    };

    updateMiniCartXHR = $.ajax({
        url: kingpalm_ajax.url,
        dataType: "json",
        type: "post",
        data: data,
        success: function (data) {
            $(document.body).trigger("wc_fragment_refresh");
        },
        error: function () {
            console.error("Send Error");
            return false;
        },
        complete: function () {
            updateMiniCartXHR = null;
        },
    });
}

// Update mini cart on quantity input
function updateMiniCartOnQuantityInput() {
    let updateMiniCartTimeoutId;

    $(document).on("input", ".block-minicart input.qty", function () {
        clearTimeout(updateMiniCartTimeoutId);

        updateMiniCartTimeoutId = setTimeout(function () {
            doUpdateMiniCart();
            clearTimeout(updateMiniCartTimeoutId);
        }, 300);
    });
}

function actionQuantityUp() {
    $('body').on('click', '.quantity-up', function () {
        quantityOnClick($(this), 'up');
    });
}
function actionQuantityDown() {
    $('body').on('click', '.quantity-down', function () {
        quantityOnClick($(this), 'down');
    });
}

// Common button quantity (4 case:quick order, cart, single product, quick-view)
function quantityOnClick(self, upDown) {

    const input = self.parent('.quantity').find('input');
    let max = input.attr('max'),
        newVal, oldValueParse = input.val();

    if (oldValueParse === '') {
        oldValueParse = 0;
    }

    let oldValue = parseFloat(oldValueParse);
    if (upDown === 'up') {
        if (max !== '' && oldValue >= max) {
            newVal = oldValue;
        } else {
            newVal = oldValue + 1;
            updateCart(self, input, newVal);
        }

    } else {
        if (oldValue === 1 || oldValue === "") {
            // $('.has-spinner').attr("disabled", "disabled");
            const quickDown = self.data('quickdown');
            if (quickDown === 'yes') {
                newVal = "";//quick-order
                updateCart(self, input, newVal)
            } else {
                newVal = 1;//other case
            }
        } else if (oldValue > 0) {
            newVal = oldValue - 1;
            updateCart(self, input, newVal);
        }
    }

}

//ater click show spinnner (shop, category-product, single-product page)
function showSpinnerForAddToCart() {
    // $( '.button' ).on( 'click', function() {
    $('body').on('click', '.button', function () {
        let btn = $(this);
        if (btn.is('[data-is-tobacco="1"]')) {
            $("#popup-redirect-to-tobacco").addClass("show");
            $("#popup-redirect-to-tobacco .btn-ok").attr("href", btn.attr('href'));
            return false;
        }
        if (btn.hasClass('add_to_cart_button') || btn.hasClass('single_add_to_cart_button') || btn.hasClass('button-submit')) {

            if (btn.hasClass('single_add_to_cart_button')) {
                const $form = btn.closest('form.cart');
                if ($form && $form.find('[name="is-tobacco"]').length) {
                    $("#popup-redirect-to-tobacco").addClass("show");
                    $("#popup-redirect-to-tobacco .btn-ok").attr("href", $form.find('[name="need-go-to"]').val());
                    return false;
                }
            }

            btn.buttonLoader('start');
            $(document).on("wc_cart_button_updated", function (e, button) {
                button.buttonLoader('stop');
            });

            if ($(btn).attr("download") || $(btn).attr("download") === "") {
                let spinnerTimeoutId = setTimeout(function () {
                    btn.buttonLoader('stop');
                    clearTimeout(spinnerTimeoutId);
                }, 1000);
            }
        }
    });
}


//add spinner for button add to cart (shop)
$.fn.buttonLoader = function (action) {
    let self = $(this);
    //start loading animation
    if (action == 'start') {
        if ($(self).attr("disabled") == "disabled") {
            e.preventDefault();
        }
        //disable buttons when loading state
        $('.has-spinner').attr("disabled", "disabled");
        $(self).attr('data-btn-text', $(self).text());
        //binding spinner element to button and changing button text
        // $(self).html('<span class="spinner"><i class="fa fa-spinner fa-spin"></i></span>');
        $(self).addClass('active');
    }
    //stop loading animation
    if (action == 'stop') {
        $(self).html($(self).attr('data-btn-text'));
        $(self).removeClass('active');
        //enable buttons after finish loading
        $('.has-spinner').removeAttr("disabled");
    }
}



// show coupon in Cart, checkout
function showCouponFields() {
    $('body').on('click', '.coupon a', function (e) {
        e.preventDefault();
        let coupon = $(this).parent('.coupon').find('.coupon-fields');
        coupon.toggle();
    });
}

/* show button back to top */
function showBackToTop() {
    $(window).scroll(function () {
        if ($(this).scrollTop() > 300) {
            $('.backtotop').addClass('show');
        } else {
            $('.backtotop').removeClass('show');
        }
    });
}

/* button scroll to top */
function backToTop() {
    $(".backtotop").on('click', function () {
        $('html, body').animate({ scrollTop: 0 }, 800);
    });
}

//slider for home page, giveaway
function articlesSlider() {
    $('.articles-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        useTransform: false,
        speed: 300,
        prevArrow: '<button type="button" class="btn-prev"><svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.8281 2.83L5.65813 12L14.8281 21.17L11.9981 24L-0.00187387 12L11.9981 -2.47406e-07L14.8281 2.83Z" fill="currentColor"/></svg></button>',
        nextArrow: '<button type="button" class="btn-next"><svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.171875 21.17L9.34188 12L0.171875 2.83L3.00187 0L15.0019 12L3.00187 24L0.171875 21.17Z" fill="currentColor"/></svg></button>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    variableWidth: true,
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 650,
                settings: {
                    arrows: false,
                    dots: true,
                    variableWidth: true,
                    slidesToShow: 2,
                },
            },
        ],
    });
}
//wholesale category page, wholesale single page
function wholesaleSlider() {
    $('.wholesale-slider').slick({
        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        // adaptiveHeight: true,
        useTransform: false,
        speed: 300,
        prevArrow: '<button type="button" class="btn-prev"><svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.8281 2.83L5.65813 12L14.8281 21.17L11.9981 24L-0.00187387 12L11.9981 -2.47406e-07L14.8281 2.83Z" fill="currentColor"/></svg></button>',
        nextArrow: '<button type="button" class="btn-next"><svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.171875 21.17L9.34188 12L0.171875 2.83L3.00187 0L15.0019 12L3.00187 24L0.171875 21.17Z" fill="currentColor"/></svg></button>',
        responsive: [
            {
                breakpoint: 1248,
                settings: {
                    slidesToShow: 3,
                    arrows: true,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    variableWidth: true,
                    // adaptiveHeight: true,
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '0px',
                    arrows: true,
                },
            },
        ],
    });

}

function singleHeroSlider() {
    $('.single-hero-slider').slick({
        dots: true,
        variableWidth: true,
        centerMode: true,
        // centerPadding: '20px',
        useTransform: false,
        speed: 300,
        prevArrow: '<button type="button" class="btn-prev"><svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.8281 2.83L5.65813 12L14.8281 21.17L11.9981 24L-0.00187387 12L11.9981 -2.47406e-07L14.8281 2.83Z" fill="currentColor"/></svg></button>',
        nextArrow: '<button type="button" class="btn-next"><svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.171875 21.17L9.34188 12L0.171875 2.83L3.00187 0L15.0019 12L3.00187 24L0.171875 21.17Z" fill="currentColor"/></svg></button>',
        responsive: [
            {
                breakpoint: 1248,
                settings: {
                    slidesToShow: 1,
                    variableWidth: true,
                    centerMode: true,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    variableWidth: true,//custom width
                },
            },
        ],
    });
}

function scrollForForm() {

    if ($("#wholesale-form div").hasClass("gform_validation_errors") || $("#wholesale-form div").hasClass("gform_confirmation_message")) {
        goScroll("#wholesale-form")
    }
}

function goScroll(selector) {
    $([document.documentElement, document.body]).animate({
        scrollTop: $(selector).offset().top
    }, 1000);
}

// Scroll mobile menu
$(document).on("ready", function () {
    $('.use-scroll .sub-menu').one('scroll swing', function () {
        let scrollBodyHeight = $('body').height();
        let scrollHeight = $('.use-scroll .sub-menu').height();
        let sum = scrollBodyHeight + scrollHeight;

        // $('.use-scroll .sub-menu').animate({scrollTop:scrollHeight}, '500', 'swing');

        $('.mobile-menu').animate({ scrollTop: scrollBodyHeight }, '500', 'swing');
        $('.use-scroll .sub-menu').animate({ scrollTop: sum }, '500', 'swing');

    });
});

jQuery(document).on('gform_post_render', function (event, form_id, current_page) {
    if (jQuery('.popup-requests-block-name').hasClass('gfield_error')) {
        jQuery('.popup-requests-block-title.block1').addClass('error');

    }
    if (jQuery('.popup-requests-block-name2').hasClass('gfield_error')) {
        jQuery('.popup-requests-block-title.block2').addClass('error');

    }
});

$(window).on("load", function () {
    if ($("body").hasClass("page-template-template-ambassador")) {
        // Show current-ambassadors page
        let icrement = 0;
        function ShowLi() {
            icrement++
            let allOpen
            if ($(window).width() > 767) {
                allOpen = $('.current-ambassadors').data('desktop-count') * icrement;
            } else {
                allOpen = $('.current-ambassadors').data('mobile_count') * icrement;
            }
            let i = 0
            for (i; i <= allOpen; i++) {
                $('body').find('ul#ambassadors_elements li:nth-child(' + i + ')').addClass("open");
            }

            let allList = $('ul#ambassadors_elements li').length;
            if (allList < allOpen) {
                $(".current-ambassadors .show_more").remove();
            }
        }
        ShowLi();

        $(".current-ambassadors .show_more").on('click', function (e) {
            e.preventDefault();
            ShowLi();
        });

        $(document).ajaxComplete(function (event, xhr, settings) {
            const urlAction = settings.data
            if (urlAction.indexOf('kingpalm_ambassador_search') !== -1) {
                ShowLi();
            }
        });
    }

    // Countdown
    if ($('.lefttopfstcontsec').length > 0) {
        setTimeout(() => {
            $('.topfstcontsec').addClass("display-opacity");
        }, 200)
    }

    if ($('#countdown').length > 0) {
        (function () {
            let dataEvent = $('#countdown').data('countdown').slice(0, -1);
            let dataEventNext = $('#countdown').data('countdown_next').slice(0, -1);
            let dataEventLast = $('#countdown').data('countdown_third').slice(0, -1);

            const second = 1000,
                minute = second * 60,
                hour = minute * 60,
                day = hour * 24;

            //I'm adding this section so I don't have to keep updating this pen every year :-)
            //remove this if you don't need it
            let today = new Date(),
                dd = String(today.getDate()).padStart(2, "0"),
                mm = String(today.getMonth() + 1).padStart(2, "0"),
                yyyy = today.getFullYear(),
                event = dataEvent,
                nextEvent = dataEventNext;

            today = mm + "/" + dd + "/" + yyyy;

            //end

            console.log(today);
            console.log("today");
            console.log("tomorrow");
            console.log("yesterday");

            const countDown = new Date(event).getTime(),
                x = setInterval(function () {

                    const now = new Date().getTime(),
                        distance = countDown - now;

                    if (distance < 0) {
                        const countDownNext = new Date(nextEvent).getTime(),
                            x2 = setInterval(function () {

                                const nows = new Date().getTime(),
                                    distances = countDownNext - nows;


                                if (distances < 0) {
                                    $('.countdown-box').css("display", "none");
                                } else {
                                    let dataMonth = dataEventNext.replace(/[\,\/]/g, '.');
                                    let onlyMonth = Number(dataMonth.slice(0, 2));
                                    switch (onlyMonth) {
                                        case 01:
                                            onlyMonth = 'January';
                                            break;
                                        case 02:
                                            onlyMonth = 'February';
                                            break;
                                        case 03:
                                            onlyMonth = 'March';
                                            break;
                                        case 04:
                                            onlyMonth = 'April';
                                            break;
                                        case 05:
                                            onlyMonth = 'May';
                                            break;
                                        case 06:
                                            onlyMonth = 'June';
                                            break;
                                        case 07:
                                            onlyMonth = 'July';
                                            break;
                                        case 08:
                                            onlyMonth = 'August';
                                            break;
                                        case 09:
                                            onlyMonth = 'September';
                                            break;
                                        case 10:
                                            onlyMonth = 'October';
                                            break;
                                        case 11:
                                            onlyMonth = 'November';
                                            break;
                                        case 12:
                                            onlyMonth = 'December';
                                            break;
                                        default:
                                            onlyMonth = 'January';
                                    }

                                    let yearStart = dataMonth.length - 4
                                    let yearEnd = dataMonth.length
                                    let onlyYear = Number(dataMonth.slice(yearStart, yearEnd));
                                    let onlyDay = Number(dataMonth.slice(3, yearStart));

                                    $('.countdown-box .next-event .next-event_data').text(`${onlyMonth} ${onlyDay} - ${onlyYear}`)

                                    let days = Math.floor(distances / (day)) >= 10 ? Math.floor(distances / (day)) : '0' + Math.floor(distances / (day));
                                    let hours = Math.floor((distances % (day)) / (hour)) >= 10 ? Math.floor((distances % (day)) / (hour)) : '0' + Math.floor((distances % (day)) / (hour));
                                    let minutes = Math.floor((distances % (hour)) / (minute)) >= 10 ? Math.floor((distances % (hour)) / (minute)) : '0' + Math.floor((distances % (hour)) / (minute));
                                    let seconds = Math.floor((distances % (minute)) / second) >= 10 ? Math.floor((distances % (minute)) / second) : '0' + Math.floor((distances % (minute)) / second);

                                    document.getElementById("days").innerText = days,
                                        document.getElementById("hours").innerText = hours,
                                        document.getElementById("minutes").innerText = minutes,
                                        document.getElementById("seconds").innerText = seconds;

                                    setTimeout(() => {
                                        let toDays = Number($('#days').text())
                                        if (toDays === 0) {
                                            $('#countdown ul li:first').css("display", "none");
                                        }
                                        setTimeout(() => {
                                            $('.countdown-box').addClass("display-countdown");
                                        }, 400)
                                    }, 10)
                                }
                            }, 200)
                    } else {
                        let dataMonth = dataEvent.replace(/[\,\/]/g, '.');
                        let onlyMonth = Number(dataMonth.slice(0, 2));
                        switch (onlyMonth) {
                            case 01:
                                onlyMonth = 'January';
                                break;
                            case 02:
                                onlyMonth = 'February';
                                break;
                            case 03:
                                onlyMonth = 'March';
                                break;
                            case 04:
                                onlyMonth = 'April';
                                break;
                            case 05:
                                onlyMonth = 'May';
                                break;
                            case 06:
                                onlyMonth = 'June';
                                break;
                            case 07:
                                onlyMonth = 'July';
                                break;
                            case 08:
                                onlyMonth = 'August';
                                break;
                            case 09:
                                onlyMonth = 'September';
                                break;
                            case 10:
                                onlyMonth = 'October';
                                break;
                            case 11:
                                onlyMonth = 'November';
                                break;
                            case 12:
                                onlyMonth = 'December';
                                break;
                            default:
                                onlyMonth = 'January';
                        }

                        let yearStart = dataMonth.length - 4
                        let yearEnd = dataMonth.length
                        let onlyYear = Number(dataMonth.slice(yearStart, yearEnd));
                        let onlyDay = Number(dataMonth.slice(3, yearStart));

                        $('.countdown-box .next-event .next-event_data').text(`${onlyMonth} ${onlyDay} - ${onlyYear}`)

                        let days = Math.floor(distance / (day)) >= 10 ? Math.floor(distance / (day)) : '0' + Math.floor(distance / (day));
                        let hours = Math.floor((distance % (day)) / (hour)) >= 10 ? Math.floor((distance % (day)) / (hour)) : '0' + Math.floor((distance % (day)) / (hour));
                        let minutes = Math.floor((distance % (hour)) / (minute)) >= 10 ? Math.floor((distance % (hour)) / (minute)) : '0' + Math.floor((distance % (hour)) / (minute));
                        let seconds = Math.floor((distance % (minute)) / second) >= 10 ? Math.floor((distance % (minute)) / second) : '0' + Math.floor((distance % (minute)) / second);

                        document.getElementById("days").innerText = days,
                            document.getElementById("hours").innerText = hours,
                            document.getElementById("minutes").innerText = minutes,
                            document.getElementById("seconds").innerText = seconds;

                        setTimeout(() => {
                            let toDays = Number($('#days').text())
                            if (toDays === 0) {
                                $('#countdown ul li:first').css("display", "none");
                            }
                            setTimeout(() => {
                                $('.countdown-box').addClass("display-countdown");
                            }, 400)
                        }, 10)

                    }
                }, 200)
        }());
    }

    // Hide text on grafity form
    $(".EnterToWin").each(function (index) {
        if (!$('div').hasClass('gform-body')) {
            $('.site-main h2').remove();
            $('.site-main h1').remove();
        }
    });
});

// Blocked Store Zip Code on enter-to-win page
function blockedZip() {
    $('body').on('change', '.EnterToWin .ginput_container_select select', function () {
        $('.state .sorry-msg').remove();
        $('.state #validation_message_3_19').remove();
        let urlData = $('.giveaway-main').data('rules_url');
        let selectedOption = String($(this).find(":selected").val());
        let obj = $('.forbidden_states').data('forbidden')
        let exists = Object.values(obj).includes(selectedOption);
        if (exists) {
            $('.postcode input').val('')
            $('.postcode input').prop('disabled', true);
            $('.state').append(`<div class="gfield_description validation_message gfield_validation_message sorry-msg">This address is not eligible for the sweepstakes, please read giveaway <a href="${urlData}">Official Rules.</a></div>`);
        } else {
            $('.postcode input').prop('disabled', false);
        }
    });
}


// Store locator
function StoreLocator() {
    // $( '.button' ).on( 'click', function() {
    $('body').on('click', '.btn-form-submit', function (e) {
        e.preventDefault()
        let event = $.Event("keypress", { which: 13 });
        $('#wpsl-search-input').trigger(event);
    });
}


//Map filter drop down

function mapFilterDropDown() {
    if ($('.dropdown-map .options p').length > 0) {
        $('.dropdown-map .options').addClass('options-border')
    }
}

// Animate on scroll
function animateOnScroll() {
    if (window.location.href.indexOf("what-is-king") > -1) {
        AOS.init();
    }
}

// Custom form validation
function validateWhatIsKingPalmForm() {
    function scrollToForm() {
        $("html, body").animate({
            scrollTop: $(".what-is-kp-form").closest(".whtkpalmkingpalm").offset().top
        }, 2000);
        return false;
    }

    // Scroll to form on success
    if ($(".what-is-kp-form .gform_confirmation_message").length !== 0) {
        scrollToForm();
    }

    // Show validation message and scroll to form on error
    if ($(".what-is-kp-form .gfield_validation_message").length !== 0) {
        const message = $(".what-is-kp-form .gfield_validation_message").text();

        $(".what-is-kp-form_wrapper").attr("data-validation-message", message);
        scrollToForm();
    }
}

// Video modal box what is king palm
$(document).ready(function () {
    // set unique id to videoplayer for the Webflow video element
    var src = $('#videoplayer').children('iframe').attr('src');

    // when object with class open-popup is clicked...
    $('.main-video-btn').click(function (e) {
        e.preventDefault();
        // change the src value of the video
        $('#videoplayer').children('iframe').attr('src', src);
        $('.modal-video-bg').addClass("visible");
    });

    // when object with class close-popup is clicked...
    $('.close-popup').click(function (e) {
        e.preventDefault();
        $('#videoplayer').children('iframe').attr('src', '');
        $('.modal-video-bg').removeClass("visible");
    });

    $(document.body).trigger('wc_fragment_refresh');

    function updateWishlistLink() {
        let $link = $('.wish-list-icon-wrapper').find('a.wish-list').first();
        if ($link.length && $link.attr('href') === '#') {
            $.ajax({
                url: kingpalm_ajax.url,
                dataType: "json",
                type: "post",
                data: {
                    action: 'kp_get_wishlist_link',
                },
                success: function (res) {
                    if (res.success) {
                        $('.wish-list-icon-wrapper').find('a.wish-list').attr('href', res.data.link);
                    }
                },
                error: function () {
                    return false;
                },
            });
        }
    }
    $('body').on('removed_from_wishlist', function () {
        if ($('.wishlist-count').length > 0) {
            const currentItemsInWishlist = parseInt($('.wishlist-count').first().text());
            const newtItemsInWishlist = currentItemsInWishlist - 1;
            $('.wishlist-count').text(newtItemsInWishlist);
            if (newtItemsInWishlist <= 0) {
                $('.wishlist-count').addClass('hidden');
            }
        }
        updateWishlistLink();
    });
    $('body').on('added_to_wishlist', function () {
        updateWishlistLink();
    });
    $('body').on('adding_to_cart', function (ev, button, data) {
        if (typeof button !== 'undefined' && typeof data !== 'undefined' && button.closest('.wishlist-user-wishlist-wrapper').length) {
            data.remove_from_wishlist_after_add_to_cart = data.product_id;
            data.wishlist_id = button.closest('.wishlist-user-wishlist-wrapper').data('id');
        }
    });

    $('body').on('added_to_cart', function (ev, fragments, carthash, button) {
        if (typeof button !== 'undefined' && button.closest('.wishlist-user-wishlist-wrapper').length) {
            if (yith_wcwl_l10n.remove_from_wishlist_after_add_to_cart) {
                button.closest('.wishlist-item').remove();
            }
        }
    });

});

$(window).on("load", function () {
    function lazyVideos() {
        const lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

        if ("IntersectionObserver" in window) {
            const lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (video) {
                    if (video.isIntersecting) {
                        for (var source in video.target.children) {
                            const videoSource = video.target.children[source];
                            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                                videoSource.src = videoSource.dataset.src;
                            }
                        }

                        video.target.load();
                        video.target.classList.remove("lazy");
                        lazyVideoObserver.unobserve(video.target);
                    }
                });
            });

            lazyVideos.forEach(function (lazyVideo) {
                lazyVideoObserver.observe(lazyVideo);
            });
        }
    }

    lazyVideos();

    if ($('body').hasClass('kp-page-free-sample') && window.location.hash.length && $(window.location.hash).length) {
        goScroll(window.location.hash);
    }
});
